module.exports = __webpack_public_path__ + "static/room2-3-778e1a4679a04f66ad581e88b32f60ff.jpg";